import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from '../common/LoadingScreen';
import { getAuthCookie } from '../utils/helpers/authHelpers';

// context

export const LoginGuard = (props) => {
    const { children } = props;
    const navigate = useNavigate();

    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if (getAuthCookie()) { // Find jwt , then redirect to product page
            navigate('/dashboard');
        } else {
            setChecked(true)
        }
    }, []);

    if (!checked) return <LoadingScreen />
    return children;
};

LoginGuard.propTypes = {
    children: PropTypes.node
};
